<template>
    <section class="bg-white container-global q-py-xl">
        <div class="">
            <div class="earn-money-section">
                <div class="q-mx-auto col col-sm-12 col-md-11 col-lg-10">
                    <div class="earn-money-container">
                        <div class="earn-money-content-wrapper">
                            <div class="earn-money-text">
                                <h2 class="earn-money-title">قيّم معنا وارفع دخلك الشهري!</h2>
                                <p class="earn-money-desc">
                                    يحصل المقيم الخبير على مقابل مادي يصل إلى 15,000 شهريًا، بالإضافة إلى دورات
                                    تدريبية
                                    مجانية تطوّر مهاراته في مجالات تجربة المستخدم!
                                </p>
                                <button role="link" class="primary_btn_outline earn-money-btn"
                                    @click="router.push({ name: 'akwadion' })">انضم كمقيم خبير</button>
                            </div>
                            <div class="earn-money-image">
                                <img src="@/assets/images/new-home/earn_mony.svg" alt="اكواد قيم وارفع دخلك الشهري"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();
</script>

<style scoped lang="scss">
.earn-money-section {
    padding-block: 60px 0;
    // background-color: #f8f9fa;
}

.earn-money-container {
    background: linear-gradient(90deg, #5854FF 0%, #8380DD 100%);
    color: white;
    border-radius: 50px;
    padding: 26px;
    margin-inline: auto;

    @media (max-width: 992px) {
        margin: 16px;
        max-width: 100%;
    }
}

.earn-money-content-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 992px) {
        flex-direction: column;

        >div {
            &:first-of-type {
                flex-direction: column;
            }

            width:100%;
            display: flex;
            justify-content:center;
            align-items: center;

        }
    }

}

.earn-money-text {
    padding-inline: 32px;
}

.earn-money-title {
    max-width: 400px;
    font-size: 2rem;
    font-weight: 500;
}

.earn-money-desc {
    max-width: 400px;

}

.earn-money-btn {
    border-color: white !important;
    width: 200px !important;
    margin-top: 26px;
    background: transparent !important;
    color: #fff !important;

    &:hover {}
}

.earn-money-image {
    position: relative;
    width: 50%;
    padding-block: 122px;

    img {
        height: 360px;
        max-width: 100%;

        @media (min-width: 992px) {
            position: absolute;
            top: -100px;
            right: 0px;
        }
    }
}
</style>